var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 8.58333C5.76596 8.58215 5.53514 8.52889 5.32426 8.42742C5.11339 8.32594 4.92774 8.1788 4.78081 7.99666L0.921639 3.32166C0.696133 3.04022 0.554226 2.70108 0.512088 2.34291C0.469949 1.98473 0.529275 1.62193 0.683305 1.29583C0.808228 1.01242 1.01209 0.770957 1.27054 0.600282C1.52899 0.429607 1.83111 0.336934 2.14081 0.333328H9.85914C10.1688 0.336934 10.471 0.429607 10.7294 0.600282C10.9879 0.770957 11.1917 1.01242 11.3166 1.29583C11.4707 1.62193 11.53 1.98473 11.4879 2.34291C11.4457 2.70108 11.3038 3.04022 11.0783 3.32166L7.21914 7.99666C7.0722 8.1788 6.88656 8.32594 6.67568 8.42742C6.46481 8.52889 6.23399 8.58215 5.99997 8.58333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.b435ca792dc6b9df1a0f77866f7383f5.svg";
export { ForwardRef as ReactComponent };